import React, { useState } from 'react';

const AboutSection = ({ user }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 150; // Increased for better user experience
  
  // Only show expand/collapse if there's content and it's long enough
  const shouldShowButton = user?.about && user.about.length > maxLength;
  const displayText = isExpanded ? user?.about : user?.about?.slice(0, maxLength);

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full mx-auto mt-4">
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-xl font-bold text-gray-900">About</h2>
      </div>

      <div className="text-gray-700 text-sm">
        {!user?.about ? (
          <p className="text-gray-500 italic">No information available here</p>
        ) : (
          <div className="space-y-2">
            <p className="whitespace-pre-wrap break-words">
              {displayText}
              {shouldShowButton && (
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="ml-1 text-blue-600 hover:text-blue-800 font-medium inline-flex items-center transition-colors"
                >
                  {isExpanded ? " Show less" : "... Show more"}
                </button>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AboutSection;